import React, { useState } from 'react';
import { useNotification } from './NotificationProvider';
import { confirmBuyTask } from '../api/api';
import { BottomSheet } from "react-spring-bottom-sheet";
import LinkButton from "./link_button";
import t from "../translate";
import { TadsWidget } from 'react-tads-widget';

const BuyFriend = () => {
  const { addNotification } = useNotification();
  const [isTADSsheetOpen, setIsTADSsheetOpen] = useState(false);
  const [tasks, setTasks] = useState(
    localStorage.getItem('buy_tasks') ? JSON.parse(localStorage.getItem('buy_tasks')) : []
  );
  const [isBottomSheetOpen, setIsBottomSheetOpen] = useState(() => {
    const saved = localStorage.getItem('buy_tasks');
    const parsed = saved ? JSON.parse(saved) : [];
    return parsed.length > 0;
  });

  const handleConfirm = async (taskId) => {
    try {
      const tasks = await confirmBuyTask(taskId);

      const currentTasks = JSON.parse(localStorage.getItem('buy_tasks')) || [];

      localStorage.setItem('buy_tasks', JSON.stringify(tasks));
      setTasks(tasks);

      if (tasks.length === 0) {
        setIsBottomSheetOpen(false);
      }
    } catch (error) {
      if (error.response.data.message !== 'Мы проверили: задание не выполнено.') {
        let newTasks = tasks.filter(task => task.signature !== taskId) || [];
        localStorage.setItem('tasks', JSON.stringify(newTasks) || []);

        setTasks(prevTasks => prevTasks.filter(task => task.signature !== taskId));
        addNotification('error', t(localStorage.getItem('lang'), 'errorMessage'));
      } else {
        addNotification('error', error.response.data.message);
      }
    }
  };

  const rewardUserByClick = async () => {
    await confirmBuyTask('tads_click');
    setIsTADSsheetOpen(false);
  };

  const onAdsNotFound = async () => {
    await confirmBuyTask('tads_click');
    setIsTADSsheetOpen(false);
  };

  if (tasks.length === 0 && !isTADSsheetOpen) {
    return null;
  }

  return (
    <>
      <BottomSheet
        open={isTADSsheetOpen}
        onDismiss={() => setIsTADSsheetOpen(false)}
        className="bottom-sheet"
      >
        <div className="handle-icon-container">
          <img className="handle-icon" src="/assets/icons/ic_arrow_right.svg" alt="handle-icon" />
        </div>
        <div className="sheet-header">
          <h2>{t(localStorage.getItem('lang'), 'needToCompleteTasks')}</h2>
        </div>
        <div className="task-list">
          <TadsWidget
            id="781"
            type="static"
            debug={false}
            onClickReward={rewardUserByClick}
            onAdsNotFound={onAdsNotFound}
          />
        </div>
      </BottomSheet>

      <BottomSheet className="bottom-sheet" open={isBottomSheetOpen} onDismiss={() => setIsBottomSheetOpen(false)}>
        <div className="handle-icon-container">
          <img className="handle-icon" src="/assets/icons/ic_arrow_right.svg" alt="handle-icon" />
        </div>
        <div className="sheet-header">
          <h2>{t(localStorage.getItem('lang'), 'needToCompleteTasks')}</h2>
        </div>
        <div className="task-list">
          {tasks.map((task, index) => (
            <LinkButton
              key={index}
              task={task}
              onTaskRemove={handleConfirm}
            />
          ))}
        </div>
      </BottomSheet>
    </>
  );
};

export default BuyFriend;
